import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { get } from "lodash";
import { format } from "date-fns";
import { Link } from "@quintype/components";
import ResponsiveImageWithFallback from "../responsive-image-with-fallback";
import { getSubscriptionURL, generateImageSources } from "../../utils/utils";
import { hasCollectionAccess } from "../../../api";
import styles from "./styles.m.css";
import Icon from "../icon";

import { GA } from "../../../integrations";

import Cookies from "universal-cookie";
const cookies = new Cookies();

const MagazineIssueCardBase = ({
  collection,
  prevIssue,
  nextIssue,
  className = "",
  cardWithImageZoom = true,
  subscriptionHost = ""
}) => {
  let buyLink = getSubscriptionURL(subscriptionHost, collection);
  const coverImageS3Key = get(collection, ["metadata", "cover-image", "cover-image-s3-key"], "");
  const coverImageMetaData = get(collection, ["metadata", "cover-image", "cover-image-metadata"], "");
  const imgAltText = get(collection, ["metadata", "magazine", "name"], "");
  const issueDate = get(collection, ["collection-date"]);
  const magazineType = get(collection, ["magazineType"]);
  const magazineName = get(collection, ["magazineEnName"]);
  const [bought, setBought] = useState(false);
  useEffect(() => {
    hasCollectionAccess(collection.id).then(({ granted }) => {
      setBought(granted);
    });
  }, []);

  const linkName = magazineName === "Motor Vikatan English" ? "Download Now" : "Buy Now";
  const downloadLink = `https://image.vikatan.com/mvenglish/pdf/${format(new Date(issueDate), "YYYYMMDD")}.pdf`;

  const handleEvent = () => {
    const id = cookies.get("vuid") || cookies.get("thinmint");
    GA.customEvent("magazineDownload", format(new Date(issueDate), "DD-MM-YYYY"), id);
  };

  return (
    <div className={`${styles["base"]} ${className} ${cardWithImageZoom ? "card-with-image-zoom" : ""}`}>
      <div className={styles["image-container"]}>
        <a
          href={
            magazineName === "Motor Vikatan English"
              ? downloadLink
              : !bought && magazineType
                ? buyLink
                : collection.pagePath
          }
        >
          <ResponsiveImageWithFallback
            className={`${styles["image-wrapper"]} qt-figure`}
            slug={coverImageS3Key}
            metadata={coverImageMetaData}
            alt={imgAltText}
            imgParams={{ auto: ["format", "compress"] }}
            sources={generateImageSources(
              { aspectRatio: [3, 4], screenWidthCoverage: 0.95 },
              { aspectRatio: [3, 4], screenWidthCoverage: 0.32 }
            )}
          />
        </a>
      </div>
      {issueDate ? (
        <div className={styles["published-date-range"]}>{format(new Date(issueDate), "DD/MM/YYYY")}</div>
      ) : null}
      {magazineName === "Motor Vikatan English" ? (
        <a
          onClick={() => handleEvent()}
          href={downloadLink}
          className={styles["buy-btn"]}
          rel="noopener noreferrer"
          target="_blank"
        >
          {linkName}
        </a>
      ) : (
        !bought &&
        magazineType &&
        buyLink && (
          <a href={buyLink} className={styles["buy-btn"]} rel="noopener noreferrer" target="_blank">
            {linkName}
          </a>
        )
      )}
      <ul className={styles["pager"]}>
        <li className={styles["pager-item"]}>
          <Link
            href={prevIssue ? prevIssue["pagePath"] : undefined}
            className={`${styles["pager-link"]} ${prevIssue ? "" : styles.disabled}`}
          >
            <Icon type="angle-left" className={styles["pager-icon"]} />
            <span>Previous Issue</span>
          </Link>
        </li>
        <li className={styles["pager-item"]}>
          <Link
            href={nextIssue ? nextIssue["pagePath"] : undefined}
            className={`${styles["pager-link"]} ${nextIssue ? "" : styles.disabled}`}
          >
            <span>Next Issue</span>
            <Icon type="angle-right" className={styles["pager-icon"]} />
          </Link>
        </li>
      </ul>
    </div>
  );
};

MagazineIssueCardBase.propTypes = {
  className: PropTypes.string,
  subscriptionHost: PropTypes.string,
  cardWithImageZoom: PropTypes.bool,
  collection: PropTypes.shape({
    metadata: PropTypes.shape({
      "cover-image": PropTypes.shape({
        "cover-image-metadata": PropTypes.shape({
          height: PropTypes.number,
          width: PropTypes.number
        }),
        "cover-image-s3-key": PropTypes.string
      }),
      magazine: PropTypes.shape({
        name: PropTypes.string
      })
    })
  }),
  config: PropTypes.shape({
    sections: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        slug: PropTypes.string
      })
    ),
    magazines: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        magazineSlug: PropTypes.string,
        name: PropTypes.string,
        url: PropTypes.string,
        vikatanMagazineId: PropTypes.number
      })
    ),
    "publisher-name": PropTypes.string
  }),
  prevIssue: PropTypes.object,
  nextIssue: PropTypes.object
};

export const MagazineIssueCard = connect(state => {
  return { subscriptionHost: get(state, ["qt", "config", "vikatanHosts", "subscription"]) };
})(MagazineIssueCardBase);

export default MagazineIssueCard;
